// auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router, CanActivateChildFn } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { OAuthService } from 'angular-oauth2-oidc';

export const AuthGuard: CanActivateFn | CanActivateChildFn = async (route, state) => {
    const authService: AuthService = inject(AuthService);
    const oauthService: OAuthService = inject(OAuthService);
    const router: Router = inject(Router);

    // If we already have a valid token, the user is authenticated.
    if (oauthService.hasValidAccessToken()) {
        // You should still check for URL permissions here if needed
        return true;
    }
    
    // If there is no valid token, run the initial login sequence.
    // This will either silently refresh the token or redirect to the login page.
    try {
        const loggedIn = await authService.runInitialLoginSequence();
        
        if (loggedIn) {
            // After a successful silent login/refresh, check URL permissions
            return true;
        }

        // If not logged in, the sequence will have already started the redirect.
        // Return false to prevent the router from navigating to the intended page.
        return false;
    } catch (error) {
        console.error('Auth Guard caught an error:', error);
        // In case of any unexpected error, redirect to login
        oauthService.initCodeFlow();
        return false;
    }
};